import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body p-15 p-sm-20 p-md-25 p-lg-30" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://www.youtube.com/embed/r7vdoYwiGIc",
    title: "How to Create Metal Textures in Photoshop",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
    allowfullscreen: ""
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-close" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "videoModal",
    class: _normalizeClass(['modal fade videoModal', { show: $setup.stateStoreInstance.video }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          type: "button",
          class: "btn-close bg-transparent text-white shadow-none",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.stateStoreInstance.videoModal && $setup.stateStoreInstance.videoModal(...args)))
        }, _hoisted_5)
      ])
    ])
  ], 2))
}